export default {
  location: [1, 2],
  status: true,
  main: {
    title: {
      2: "欢迎光临本味主义",
      3: "本味主義をリニューアルしました！",
      4: "歡迎光臨本味主義"
    },
    fontSize: 20
  },
  sub: {
    title: {
      2: "商城全新升级，完美体验轻松购物！",
      3: "本味主義をリニューアルしました！",
      4: "商城全新升級，完美體驗輕松購物！"
    },
    fontSize: 14
  },
  pathlink: "",
  bgColor: "#b4a172",
  textColor: "#fbfbfd"
};